import * as React from 'react';
import * as _ from 'lodash';
import { ConnectedProps, connect } from 'react-redux';
import { exportLogs, readLogs, markLogsAsRead, exportDialogs } from '../../../../redux/projects/actions.projects';
import logLevels from '../../../../const/logLevels';
import phraseTypes from '../../../../const/phraseTypes';
import FilterCheckbox from '../../../components/FilterCheckbox/FilterCheckbox';
import cancelEvent from '../../../../services/mini/cancelEvent';
import * as scriptEditorActions from '../../../../redux/scriptEditor/actions.scriptEditor';
import FilterDelimiter from '../../../components/FilterDelimiter/FilterDelimiter';
import FilterByLine from '../../../components/FilterByLine/FilterByLine';
import TileTooltip from '../../../components/TileTooltip/TileTooltip';
import tooltips from '../../../../const/tooltips';
import ReactTooltip from 'react-tooltip';
import tooltipService from '../../../../services/tooltipService';
import device from '../../../../services/mini/device';
import { List, AutoSizer } from 'react-virtualized/dist/commonjs';
import projectLogsKeeper from '../../../../services/dataKeepers/ProjectLogsKeeper';
import LoaderWithCircle from '../../../components/LoaderWithCircle/LoaderWithCircle';
import LogLineTooltip from '../../../components/LogLine/LogLineTooltip';
import {
    PHRASE_FILTER,
    PATTERN_FILTER,
    DIALOG_FILTER,
    OUTPUT_PHRASES,
    INPUT_PHRASES,
    UNRECOGNIZED_PHRASES,
    INFO,
    RUNTIME_ERROR,
    PATTERNHASH_FILTER
} from '../../../../const/logFilters';
import FilterLabel from '../../../components/FilterLabel/FilterLabel';
import getColorByText from '../../../../services/mini/getColorByText';
import FilterRectCheckbox from '../../../components/FilterRectCheckbox/FilterRectCheckbox';
import { Loader, LoaderSize, LoaderTheme } from '../../../components/Loader/Loader';
import LogLineWrapper from '../../../components/LogLine/LogLineWrapper';
import { Resizer } from '../../../components/Resizer/Resizer';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { IScript } from '../../../../models/IScript';
import { IProject } from '../../../../models/IProject';
import { IHighlightLineParams } from '../../../../redux/scriptEditor/actions.scriptEditor';
import { ISyntaxError } from '../../../../models/ISyntaxError';
import { ILog } from '../../../../models/ILog';
import { ILogFilters } from '../../../../models/ILogFilters';
import { Environment } from '../../../../const/environment';
import { insertModelUpdatedLogSeprator, insertTodayLogSeprator } from '../../../../services/mini/insertTodayLogSeprator';
import { icons } from '../../../../services/icons';
import ToasterService from '../../../../services/ToasterService';

const { default: noSyntaxErrImg } = require("../../../../assets/images/logs/no-logs-02-pic@2x.png");
const { default: noLogsImg } = require("../../../../assets/images/logs/no-logs-01-pic@2x.png");

type ErrorPanelProps = {
    syntaxErrors: ISyntaxError[],
    logs: ILog[],
    filters: ILogFilters,
    hiddenFilters: ILogFilters,
    environment: Environment,
    script: IScript,
    project: IProject,
    logsUpdatedTs: number,
    filterUpdateTs: number,
    scriptsHash: string,
    hasFilterByPhrases: boolean,
    exportingLogs: boolean,
    exportingDialogs: boolean,
    hasLoadedLogs: boolean,
    parentCont: HTMLDivElement,
    setPatternFilter: (filter: string, hash: string) => void,
    resetPatternFilter: () => void,
    resetPhraseTextFilter: () => void,
    resetAllPhrasesFilters: () => void,
    resetEntityFilter: (entity: string) => void,
    resetDialogFilter: () => void,
    resetPhraseFilterCb: (e: React.MouseEvent) => void,
    clearLogsCb: (e: React.MouseEvent) => void,
    setFilterCb: (filterName: string, filterValue: string, e: React.MouseEvent) => void,
    highlightLine: (param: IHighlightLineParams) => void,
    setStageMode: (arg: boolean) => void,//todo: check it
    onResize: () => void,
} & PropsFromRedux;

type ErrorPanelState = {
    renderTs: number,
    lastScrollTs: number,
    isResized: boolean,
    showLogTooltip: boolean,
    errorPanelOpened: boolean,
    showTooltip: boolean,
    logRequestCounter: number,
    jsonObjIndexToOpen: number,
};

const DEBUG_LOGS_LS_KEY = 'debug_studio_logs';

const LIST_ROW_HEIGHT = 24; // log line height (defined in css)
const OVERSCAN_ROW_COUNT = 2;
class ErrorPanel extends React.Component<ErrorPanelProps, ErrorPanelState> {

    errorPanelRef = React.createRef<HTMLDivElement>();
    resizer = React.createRef<Resizer>();
    list = null;
    readLogsTimerId = null;
    requestInProcess = false;
    requestInProcessTimer = null;
    autoscroll = true;
    firstRenderList = true;
    scrolledToLastLog = false;
    scrolledCurLog: ILog = undefined;
    renderAfterFilters: boolean = undefined;
    scrolledToBottom: boolean = undefined;

    constructor(props) {
        super(props);
        this.state = {
            renderTs: 0,
            lastScrollTs: 0,
            isResized: false,
            showLogTooltip: false,
            errorPanelOpened: false,
            showTooltip: false,
            logRequestCounter: 0,
            jsonObjIndexToOpen: 0,
        };
    }

    componentDidMount() {
        window.addEventListener('updateLogs', this.updateLogs, false);
        window.addEventListener('mousedown', this.handleClickOutsideCb, false);

        const { project } = this.props;
        if (!this.readLogsTimerId) {
            if (project && project.hasScriptsData && project.scripts.length > 0 && project.scriptsHash) {
                this.startLogsReader();
            }
        }
    }

    componentDidUpdate(prevProps, nextState) {
        let project;
        const curProps = this.props;

        if (!this.readLogsTimerId) {
            project = curProps.project;
            if (project && project.hasScriptsData && project.scripts.length > 0 && project.scriptsHash) {
                this.startLogsReader();
            }
        }

        if (curProps.hiddenFilters.currentDialog !== prevProps.hiddenFilters.currentDialog) {
            this.firstRenderList = true;
        }

        if (curProps.hiddenFilters.inFile !== prevProps.hiddenFilters.inFile) {
            this.firstRenderList = true;
        }

        if (this.state.errorPanelOpened !== nextState.errorPanelOpened && nextState.errorPanelOpened === true) {
            this.autoscroll = true;
        }

        if (
            (curProps.hiddenFilters.info && !prevProps.hiddenFilters.info) ||
            (curProps.syntaxErrors && !prevProps.syntaxErrors) ||
            (curProps.hiddenFilters.runtimeErrors && !prevProps.hiddenFilters.runtimeErrors) ||
            (curProps.hiddenFilters.inputPhrases && !prevProps.hiddenFilters.inputPhrases) ||
            (curProps.hiddenFilters.outputPhrases && !prevProps.hiddenFilters.outputPhrases) ||
            (curProps.hiddenFilters.unrecognizedPhrases && !prevProps.hiddenFilters.unrecognizedPhrases)
        ) {
            this.scrolledToLastLog = false;
        }

        if (prevProps.filterUpdateTs !== curProps.filterUpdateTs) {
            setTimeout(() => {
                if (this.list) {
                    this.list.forceUpdateGrid();
                }
            });
        }

        if (curProps.syntaxErrors.length === 0 && curProps.filters['syntaxErrors']) {
            if (this.state.showLogTooltip) {
                this.closeLogTooltip();
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('updateLogs', this.updateLogs, false);
        window.removeEventListener('mousedown', this.handleClickOutsideCb, false);
        clearInterval(this.readLogsTimerId);
        this.readLogsTimerId = null;
    }

    shouldComponentUpdate(nextProps, nextState) {
        const curProps = this.props;
        const curState = this.state;

        if (curState.errorPanelOpened !== nextState.errorPanelOpened) {
            return true;
        }

        if (curProps.script && nextProps.script &&
            curProps.script.name !== nextProps.script.name) {
            return true;
        }

        if (curProps.logsUpdatedTs !== nextProps.logsUpdatedTs) {
            return true;
        }

        if (curProps.filterUpdateTs !== nextProps.filterUpdateTs) {
            return true;
        }

        if (curProps.scriptsHash !== nextProps.scriptsHash) {
            return true;
        }

        if (curProps.exportingLogs !== nextProps.exportingLogs) {
            return true;
        }

        if (curProps.exportingDialogs !== nextProps.exportingDialogs) {
            return true;
        }

        if (curState.lastScrollTs !== nextState.lastScrollTs) {
            return true;
        }

        if (curState.renderTs !== nextState.renderTs) {
            return true;
        }

        if (curState.isResized !== nextState.isResized) {
            return true;
        }

        if (curProps.hasLoadedLogs !== nextProps.hasLoadedLogs) {
            return true;
        }

        if (curState.showLogTooltip !== nextState.showLogTooltip) {
            return true;
        }

        if (JSON.stringify(curProps.filters) !== JSON.stringify(nextProps.filters)) {
            return true;
        }

        return false;
    }

    refreshLogs = () => {
        this.readLogs();
    }

    startLogsReader = () => {
        this.readLogs(null, true);

        clearInterval(this.readLogsTimerId);
        this.readLogsTimerId = setInterval(() => {
            if (process.env.NODE_ENV === 'production') {
                this.readLogs();
            } else {
                if (!localStorage.getItem(DEBUG_LOGS_LS_KEY)) {
                    this.readLogs();
                }
            }
        }, 2000);
    }

    exportLogsPreventMissClicks = _.debounce(() => {
        const { script, project, filters, environment, exportLogs } = this.props;
        ToasterService.showInfo({ title: `Exporting logs has started. They will be available in the Downloads folder once the process is complete. Please check the browser's downloads tray to confirm when the export is finished.` });
        exportLogs({
            project,
            script,
            filters,
            environment
        });
    }, 400);

    exportDialogsPreventMissClicks = _.debounce(() => {
        const { script, project, filters, environment, exportDialogs } = this.props;
        ToasterService.showInfo({ title: `Exporting dialogs has started. They will be available in the Downloads folder once the process is complete. Please check the browser's downloads tray to confirm when the export is finished.` });
        exportDialogs({
            project,
            script,
            filters,
            environment
        });
    }, 400);


    onExportLogsClick = (e) => {
        this.exportLogsPreventMissClicks();
        cancelEvent(e);
    }

    onExportDialogsClick = (e) => {
        this.exportDialogsPreventMissClicks();
        cancelEvent(e);
    }

    readLogs = (currentFilters?: ILogFilters, onlyActiveFilters?: boolean) => {
        const { script, project, logs, filterUpdateTs } = this.props;
        let { filters } = this.props;
        if (currentFilters) {
            filters = currentFilters;
        }

        if (onlyActiveFilters) {
            this.setState({ logRequestCounter: 0 });
            filters.lastTs = 0;
        }

        this.setState(prev => ({ logRequestCounter: prev.logRequestCounter + 1 }));

        if (logs.length > 0 && this.state.logRequestCounter > 2) {
            if (_.isNumber(filters.lastTs)) {
                filters.lastTs = Math.max(filters.lastTs, (+logs[logs.length - 1].ts));
            } else {
                filters.lastTs = +logs[logs.length - 1].ts;
            }
        }

        if (!window.navigator.onLine) {
            return;
        }

        if (!this.requestInProcess) {
            this.requestInProcess = true;
            this.requestInProcessTimer = setTimeout(() => {
                this.requestInProcess = false;
            }, 8000);

            this.props.readLogs({
                project,
                script,
                filters,
                environment: this.props.environment,
                onlyActiveFilters,
                filterUpdateTs
            }).then(() => {
                this.requestInProcess = false;
                clearTimeout(this.requestInProcessTimer);
                this.requestInProcessTimer = null;
            }, () => {
                this.requestInProcess = false;
                clearTimeout(this.requestInProcessTimer);
                this.requestInProcessTimer = null;
            });
        }
    }

    setFilter = (filterName, filterValue, e) => {
        this.renderAfterFilters = true;
        this.props.setFilterCb(filterName, filterValue, e);
        _.defer(() => {
            const { filters } = this.props;
            this.readLogs(filters, true);
        });
    }

    setPatternFilter = (filter, hash) => {
        this.renderAfterFilters = true;
        this.props.setPatternFilter(filter, hash);
        _.defer(() => {
            const { filters } = this.props;
            this.readLogs(filters, true);
        });
    }

    resetPatternFilter = () => {
        this.props.resetPatternFilter();
        _.defer(() => {
            const { filters } = this.props;
            this.readLogs(filters, true);
        });
    }

    closeCmdSTooltip = () => {
        this.setState({ showTooltip: false });
        ReactTooltip.hide(document.getElementById(tooltips.cmsS));
        tooltipService.saveCmdSTooltipState();
    }

    handleClickOutsideCb = (e) => {
        const log = projectLogsKeeper.logInTooltip;
        const el = e.target;

        if (_.isEmpty(log)) {
            return;
        }

        if (el.className.length > 0) {
            if (el.className.indexOf('filter-checkbox') > -1) {
                this.closeLogTooltip();
            }
        }
    }

    openLogTooltip = () => {
        this.setState({ showLogTooltip: true });
    }

    closeLogTooltip = () => {
        projectLogsKeeper.logInTooltip = {};
        this.setState({ showLogTooltip: false });
    }

    goToErrorToFile(errInfo) {
        this.goToError({ ...errInfo, ...{ line: 0, character: 0 } });
    }

    goToErrorToLine = (errInfo) => {
        this.goToError({ ...errInfo, ...{ character: 0 } });
    }

    goToErrorToChar = (errInfo) => {
        this.goToError(errInfo);
    }

    goToError = (errInfo) => {
        if (this.props.setStageMode) {
            this.props.setStageMode(true);
        }

        this.props.highlightLine({
            scriptName: errInfo.file,
            lineNumber: errInfo.line,
            character: errInfo.character,
            lineType: 'error',
            project: this.props.project
        });
    }

    showMoreMessages = (e) => {
        this.autoscroll = true;
        this.scrollListToBottom(e);
    }

    scrollListToBottom = (e?: React.MouseEvent) => {
        const allLogs = this.getDisplayedLogs();

        if (e) {
            this.setState({ lastScrollTs: Date.now() });
        }

        if (this.list) {
            this.list.scrollToRow(allLogs.length);
        }
    }

    scrollLogsToFirstUnreadMsg = () => {
        const allLogs = this.getDisplayedLogs();
        const unreadLogIndex = _.findIndex(allLogs, { 'new': true });
        if (this.list) {
            if (unreadLogIndex !== -1) {
                this.list.scrollToRow(unreadLogIndex);
            }
        }
    }

    handleJsonObjClick = (ind) => {
        this.setState({ jsonObjIndexToOpen: ind });
    }

    rowRenderer = (option) => {
        const { filterUpdateTs, filters, environment } = this.props;
        const log = this.getDisplayedLogs()[option.index];

        return <LogLineWrapper
            key={`${option.key}`}
            {...option}
            logs={this.getDisplayedLogs()}
            log={log}
            goToCb={this.goToErrorToLine}
            onHover={this.onHover}
            environment={environment}
            closeLogTooltipCb={this.closeLogTooltip}
            openLogTooltipCb={this.openLogTooltip}
            setFilterByPhraseCb={this.setFilterByPhrase}
            filterUpdateTs={filterUpdateTs}
            filters={filters}
            onJsonObjClick={this.handleJsonObjClick}
        />;
    }

    onRowsRendered = _.debounce(({ startIndex, stopIndex }) => {
        const opened = this.resizer.current?.state.isOpened;

        if (opened) {
            const logs = this.getDisplayedLogs();

            this.scrolledCurLog = logs[startIndex];

            if (this.firstRenderList) {
                this.firstRenderList = false;
                this.scrollListToBottom();
                return;
            }

            if (this.autoscroll) {
                this.scrollListToBottom();
            }

            if (logs[stopIndex]?.id !== logs[logs.length - 1]?.id) {
                if (this.scrolledToBottom) {
                    this.scrolledToBottom = false;
                    this.setState({ renderTs: Date.now() });
                }
            } else {
                this.setState({ lastScrollTs: Date.now() });
            }

            ReactTooltip.rebuild();
        }
    }, 300);

    handleScroll = ({ clientHeight, scrollHeight, scrollTop }) => {
        if (clientHeight > 0) {
            if (
                (scrollHeight - scrollTop === clientHeight) ||
                (scrollTop === 0 && clientHeight > scrollHeight)
            ) { // we at the end of the list
                this.scrolledToBottom = true;
                this.changeStateAfterScroll();
            } else {
                this.scrolledToBottom = false;
            }
            if (clientHeight < scrollHeight && scrollHeight - scrollTop !== clientHeight) {
                this.autoscroll = false;
            }
        }
    }

    updateLogs = (e) => {
        if (e && e.type === 'updateLogs') {
            this.scrolledToLastLog = false;
        }
    }

    markLogsAsReadWithFilter = ({ logFilterType, logLevel }) => {
        const { markLogsAsRead, project, environment } = this.props;
        markLogsAsRead({ projectId: project.projectId, environment, filters: { logFilterType, logLevel } });
    }

    onHover = ({ log }) => {
        if (log.new) {
            const { markLogsAsRead, environment, project, filterUpdateTs } = this.props;

            markLogsAsRead({ projectId: project.projectId, environment, log, filterUpdateTs });
        }
    }

    changeStateAfterScroll = _.debounce(() => {
        this.setState({ lastScrollTs: Date.now() });
    }, 300);

    setRuntimeErrorsFilter = (e) => {
        this.setFilter('runtimeErrors', null, e);
    }

    setSyntaxErrorFilter = (e) => {
        this.setFilter('syntaxErrors', null, e);
        this.props.openErrors({ shouldScrollToFirstError: true });
    }

    setInfoFilter = (e) => {
        this.setFilter('info', null, e);
    }

    setUnrecognizedPhrasesFilter = (e) => {
        this.setFilter(UNRECOGNIZED_PHRASES, null, e);
    }

    setInputPhrasesFilter = (e) => {
        this.setFilter(INPUT_PHRASES, null, e);
    }

    setOutputPhrasesFilter = (e) => {
        this.setFilter(OUTPUT_PHRASES, null, e);
    }

    setInFileFilter = (e) => {
        this.setFilter('inFile', null, e);
    }

    setCurrentDialogFilter = (e) => {
        this.setFilter('currentDialog', null, e);
    }

    setFilterByPhrase = (filterName, filterValue, e) => {
        this.setFilter(filterName, filterValue, e);
    }

    getTooltipContent = () => {
        const {
            project,
            environment,
            filters,
            filterUpdateTs
        } = this.props;

        const log = projectLogsKeeper.logInTooltip;

        return <LogLineTooltip
            filterUpdateTs={filterUpdateTs}
            log={log}
            projectId={project.projectId}
            goToCb={this.goToErrorToLine}
            closeLogTooltip={this.closeLogTooltip}
            environment={environment}
            filters={filters}
            setFilterByPhrase={this.setFilterByPhrase}
            setPatternFilter={this.setPatternFilter}
            resetPatternFilter={this.resetPatternFilter}
            jsonObjIndexToOpen={this.state.jsonObjIndexToOpen}
        />;
    }

    togglePanel = (e) => {
        e.stopPropagation();

        if (!this.resizer.current?.state.isOpened) {
            this.scrollLogsToFirstUnreadMsg();
        }

        this.errorPanelRef.current?.setAttribute('style', '');

        this.resizer.current?.toggle(null);
    }

    collapseErrorPanel = () => {
        this.errorPanelRef.current?.setAttribute('style', '');
        this.resizer.current?.collapse(null);
    };

    setListInView = (ref) => {
        this.list = ref;
    }

    renderList = ({ height, width }) => {
        const { logsUpdatedTs } = this.props;
        const displayedLogs = this.getDisplayedLogs();
        let scrollToIndex = this.autoscroll ? displayedLogs.length : undefined;

        if (this.scrolledCurLog && this.renderAfterFilters) {
            this.renderAfterFilters = false;
            scrollToIndex = _.findIndex(displayedLogs, { id: this.scrolledCurLog.id });
            if (scrollToIndex === -1) {
                for (let i = 0; i < displayedLogs.length; i++) {
                    if (displayedLogs[i].ts > this.scrolledCurLog.ts) {
                        this.scrolledCurLog = displayedLogs[i];
                        scrollToIndex = i;
                        break;
                    }
                }
            }
        }

        return <List
            ref={this.setListInView}
            height={height - 3}
            overscanRowCount={OVERSCAN_ROW_COUNT}
            rowCount={displayedLogs.length}
            onScroll={this.handleScroll}
            logsUpdatedTs={logsUpdatedTs}
            onRowsRendered={this.onRowsRendered}
            rowHeight={LIST_ROW_HEIGHT}
            scrollToIndex={scrollToIndex}
            scrollToAlignment="start"
            rowRenderer={this.rowRenderer}
            width={width} />;
    }

    getEntityFilterLabel(entity) {
        const filterParts = entity[Object.keys(entity)[0]].split('_');
        if (filterParts.length > 1) {
            return <span className="filter-label-entity" style={{ backgroundColor: `${getColorByText(filterParts[0], .8)}` }}>{filterParts[1]} {filterParts[0]}</span>;
        }
        return <span className="filter-label-entity" style={{ backgroundColor: `${getColorByText(filterParts[0], .8)}` }}>{filterParts[0]}</span>;
    }

    onResizeStart = () => {
        this.setState({ isResized: true });
    }

    onResizeEnd = ({ height }) => {
        this.setState({ isResized: false });
        if (height < 80) {
            this.collapseErrorPanel();
            return false;
        }
        return true;
    };

    getDisplayedLogs() {
        let {
            syntaxErrors,
        } = this.props;

        const {
            script,
            logs,
            filters,
        } = this.props;

        const scriptName = script.name;

        let displayedLogs;
        let filterCount = 0;

        for (var key in filters) {
            if (!['phraseLineNumber', 'inFile', 'currentDialog'].includes(key))
                if (filters[key] === true) {
                    filterCount++;
                }
        }

        if (filters.inFile) {
            syntaxErrors = _.filter(syntaxErrors, { level: logLevels.syntaxError, file: scriptName });
        }

        displayedLogs = [...syntaxErrors, ...logs];

        if (filters[DIALOG_FILTER] && !filters.syntaxErrors) {
            displayedLogs = _.filter(displayedLogs, { dialogId: filters[DIALOG_FILTER] });
        }

        if (filters.inFile) {
            displayedLogs = _.filter(displayedLogs, { file: scriptName });
        }

        if (!filters.syntaxErrors) {
            displayedLogs = _.filter(displayedLogs, function (el) {
                return el.level !== logLevels.syntaxError;
            });
        }

        if (!filters.runtimeErrors) {
            displayedLogs = _.filter(displayedLogs, function (el) {
                return el.level !== logLevels.runTimeError;
            });
        }

        if (!filters.info) {
            displayedLogs = _.filter(displayedLogs, function (el) {
                return el.level !== logLevels.info;
            });
        }

        if (!filters.inputPhrases) {
            displayedLogs = _.filter(displayedLogs, function (el) {
                let phraseType;
                if (el.type) {
                    phraseType = phraseTypes[el.type.toLowerCase()];
                    if (phraseType === phraseTypes.input && el.notFound === false) {
                        return false;
                    }
                    return true;
                }

                return true;
            });
        }

        if (!filters.outputPhrases) {
            displayedLogs = _.filter(displayedLogs, function (el) {
                let phraseType;
                if (el.type) {
                    phraseType = phraseTypes[el.type.toLowerCase()];
                    if (phraseType !== phraseTypes.output) {
                        return true;
                    }
                    return false;
                }

                return true;
            });
        }

        if (!filters.unrecognizedPhrases) {
            displayedLogs = _.filter(displayedLogs, function (el) {
                let phraseType;
                if (el.type) {
                    phraseType = phraseTypes[el.type.toLowerCase()];
                    if (phraseType === phraseTypes.input || phraseType === phraseTypes.output) {
                        return el.notFound === false;
                    }
                }

                return true;
            });
        }


        if (filters.phraseLineNumber) {
            displayedLogs = _.filter(displayedLogs, function (el) {
                return el.line === filters.phraseLineNumber && el.file === scriptName;
            });
        }

        if (filters[PATTERNHASH_FILTER]) {
            displayedLogs = _.filter(displayedLogs, function (el) {
                return el.patternHash === filters[PATTERNHASH_FILTER];
            });
        }

        if (!filters.syntaxErrors) {
            return insertModelUpdatedLogSeprator(insertTodayLogSeprator(displayedLogs, new Date()));
        }

        return displayedLogs;
    }

    onResizerStateChange = (state) => {
        if (state.isOpened !== this.state.errorPanelOpened) {
            this.setState({
                errorPanelOpened: state.isOpened,
            }, () => {
                if (state.isOpened) {
                    this.scrollListToBottom();
                }
            });
        }
        if (this.props.onResize) {
            this.props.onResize();
        }
    };

    render() {
        const {
            script,
            logs,
            logsUpdatedTs,
            filters,
            project,
            hiddenFilters,
            resetPatternFilter,
            resetPhraseTextFilter,
            hasFilterByPhrases,
            resetAllPhrasesFilters,
            resetEntityFilter,
            resetDialogFilter,
            hasLoadedLogs
        } = this.props;

        const opened = this.state.errorPanelOpened;

        let { syntaxErrors } = this.props;

        const { lastScrollTs, isResized, showLogTooltip } = this.state;
        let errorsCount,
            noLogsMessage = 'No logs',
            noLogsImgEl = noLogsImg,
            runtimeErrors = [],
            infoLogs = [],
            inputPhrases = [],
            outputPhrases = [],
            unrecognisedPhrases = [];

        let displayedLogs;
        let filterCount = 0;

        const scriptName = script.name;

        for (var key in filters) {
            if (!['phraseLineNumber', 'inFile', 'currentDialog'].includes(key))
                if (filters[key] === true) {
                    filterCount++;
                }
        }

        const filterCheckBoxClass = filterCount === 1 ? 'only-one-filter' : '';
        let syntaxFilterTitle = 'Syntax OK';

        errorsCount = syntaxErrors.length;

        if (filters.inFile) {
            syntaxErrors = _.filter(syntaxErrors, { level: logLevels.syntaxError, file: scriptName });
            errorsCount = syntaxErrors.length;
        }
        if (errorsCount > 0) {
            syntaxFilterTitle = 'Syntax errors';
        }

        const allSyntaxErrorsAreWarnings = syntaxErrors.length === _.filter(syntaxErrors, { isWarning: true }).length;

        displayedLogs = [...syntaxErrors, ...logs];

        if (filters.inFile) {
            displayedLogs = _.filter(displayedLogs, { file: scriptName });
        }

        runtimeErrors = _.filter(displayedLogs, { level: logLevels.runTimeError, 'new': true });

        infoLogs = _.filter(displayedLogs, { level: logLevels.info, 'new': true });

        const phrases = _.filter(logs, (phrase) => {
            return phrase.type && phrase.new === true;
        });

        inputPhrases = _.filter(phrases, (phrase) => {
            const phraseType = phraseTypes[phrase.type.toLowerCase()];
            return phraseType === phraseTypes.input && phrase.new === true;
        });

        outputPhrases = _.filter(phrases, (phrase) => {
            const phraseType = phraseTypes[phrase.type.toLowerCase()];
            return phraseType === phraseTypes.output && phrase.new === true;
        });

        unrecognisedPhrases = _.filter(phrases, function (phrase) {
            let phraseType;
            if (phrase.type) {
                phraseType = phraseTypes[phrase.type.toLowerCase()];
                if (phraseType === phraseTypes.input || phraseType === phraseTypes.output) {
                    return phrase.notFound === true && phrase.new === true;
                }
            }
            return true;
        });

        const runtimeErrorCount = runtimeErrors.length;
        const infoLogCount = infoLogs.length;
        const inputPhrasesCount = inputPhrases.length;
        const outputPhrasesCount = outputPhrases.length;
        const unrecognisedPhrasesCount = unrecognisedPhrases.length;

        const syntaxErrorsLastTs = syntaxErrors.length ? +syntaxErrors[syntaxErrors.length - 1].ts : 0;
        const runtimeErrorsLastTs = runtimeErrors.length ? +runtimeErrors[runtimeErrors.length - 1].ts : 0;
        const infoLogLastTs = infoLogs.length ? +infoLogs[infoLogs.length - 1].ts : 0;
        const inputPhrasesLastTs = inputPhrases.length ? +inputPhrases[inputPhrases.length - 1].ts : 0;
        const outputPhrasesLastTs = outputPhrases.length ? +outputPhrases[outputPhrases.length - 1].ts : 0;
        const unrecognisedPhrasesLastTs = unrecognisedPhrases.length ? +unrecognisedPhrases[unrecognisedPhrases.length - 1].ts : 0;

        displayedLogs = this.getDisplayedLogs();

        if (filters.syntaxErrors && errorsCount === 0) {
            noLogsMessage = 'No syntax errors';
            noLogsImgEl = noSyntaxErrImg;
        } else if (filters.runtimeErrors &&
            !filters.info &&
            !filters.inputPhrases &&
            !filters.outputPhrases &&
            !filters.unrecognizedPhrases &&
            runtimeErrorCount === 0) {
            noLogsMessage = 'No runtime errors';
        }

        const dialogAndScriptfilters = <div className="error-panel_dialog-and-script-filters">
            <FilterDelimiter height="22px" autoVerticalPosition={true} />
            <div className="error-panel_filters_group_label">filters</div>
            {!filters['syntaxErrors'] && <FilterRectCheckbox
                label="Cur. dialog"
                disabled={!!filters[DIALOG_FILTER]}
                onClick={this.setCurrentDialogFilter}
                value={filters['currentDialog']} />
            }
            <FilterRectCheckbox
                label="Cur. script"
                onClick={this.setInFileFilter}
                value={filters['inFile']} />

            <FilterByLine
                classes="in-second-row"
                line={+filters['phraseLineNumber']}
                resetLineFilter={this.props.resetPhraseFilterCb} />
        </div>;

        const filtersCount = (filters[PHRASE_FILTER] && 1) + (filters[PATTERN_FILTER] && 1) + (filters[DIALOG_FILTER] && 1) + filters.entities.length;

        const showResetAllBtn = filtersCount > 1;

        const lastLogTs = displayedLogs.length > 0 ? +displayedLogs[displayedLogs.length - 1].ts : 0;

        const showRefreshLogsBtn = localStorage.getItem(DEBUG_LOGS_LS_KEY);

        return (
            <Resizer
                lsKey={'ErrorPanelResizerRoot'}
                ref={this.resizer}
                x={100}
                y={50}
                min={0}
                max={90}
                onStateChange={this.onResizerStateChange}
                onResizeStart={this.onResizeStart}
                onResizeEnd={this.onResizeEnd}
                styleName={'error-panel__resizer'}
                divider={'top'}>
                <div
                    className={`error-panel ${opened && 'opened'} ${isResized && 'resized'} ${!filters.syntaxErrors && hasFilterByPhrases && 'has-phrase-filters'}`}
                    ref={this.errorPanelRef}>
                    {this.state.showTooltip && <TileTooltip tooltipId={tooltips.cmsS}
                        tooltipPlace="left"
                        tooltipClass="cmd-s-tooltip">
                        <div>Use <b>{device.isWindows() ? 'Ctrl' : 'CMD'}</b> + <b>S</b> to save<br /> changes in the script
                        </div>
                        <div className="alan-tooltip-got-it" onClick={this.closeCmdSTooltip}>Got It
                        </div>
                    </TileTooltip>}
                    <div className="error-panel_header" onClick={!opened ? this.togglePanel : null}>
                        <div className="error-panel_filters">

                            <div className="error-panel_filters_row error-panel_first-row">
                                <div className="error-panel_first-row_filters">
                                    <div className="error-panel_filters_group">
                                        <FilterCheckbox
                                            type="error"
                                            label={syntaxFilterTitle}
                                            count={errorsCount}
                                            classes={`${filterCheckBoxClass} syntax-error-ch ${allSyntaxErrorsAreWarnings && 'warnings'}`}
                                            isNew={syntaxErrorsLastTs > lastScrollTs}
                                            onClick={this.setSyntaxErrorFilter}
                                            value={filters['syntaxErrors']} />
                                    </div>

                                    <FilterDelimiter height="22px" autoVerticalPosition={true} />

                                    <div className="error-panel_filters_group">
                                        <div className="error-panel_filters_group_label">logs</div>
                                        <div className="error-panel_filters_group_body">
                                            <FilterCheckbox
                                                type="error"
                                                label="Errors"
                                                logLevel={logLevels.runTimeError}
                                                logFilterType={RUNTIME_ERROR}
                                                count={runtimeErrorCount}
                                                isNew={runtimeErrorsLastTs > lastScrollTs}
                                                classes={filterCheckBoxClass + ' runtime-error-ch'}
                                                onClick={this.setRuntimeErrorsFilter}
                                                value={filters['runtimeErrors']} />

                                            <FilterCheckbox
                                                type="info"
                                                label="Info"
                                                logLevel={logLevels.info}
                                                logFilterType={INFO}
                                                count={infoLogCount}
                                                isNew={infoLogLastTs > lastScrollTs}
                                                classes={filterCheckBoxClass + ' info-ch'}
                                                onClick={this.setInfoFilter}
                                                onReadLogs={this.markLogsAsReadWithFilter}
                                                value={filters['info']} />
                                        </div>


                                    </div>
                                    <FilterDelimiter height="22px" />

                                    <div className="error-panel_filters_group">
                                        <div className="error-panel_filters_group_label">phrases</div>
                                        <div className="error-panel_filters_group_body">
                                            {!hiddenFilters.inputPhrases &&
                                                <FilterCheckbox
                                                    type="phrase"
                                                    label="Input"
                                                    logLevel={logLevels.phrase}
                                                    logFilterType={INPUT_PHRASES}
                                                    count={inputPhrasesCount}
                                                    classes={filterCheckBoxClass + ' input-phrases-ch'}
                                                    isNew={inputPhrasesLastTs > lastScrollTs}
                                                    onClick={this.setInputPhrasesFilter}
                                                    onReadLogs={this.markLogsAsReadWithFilter}
                                                    value={filters[INPUT_PHRASES]} />}
                                            {!hiddenFilters.outputPhrases &&
                                                <FilterCheckbox
                                                    type="phrase"
                                                    label="Output"
                                                    logLevel={logLevels.phrase}
                                                    logFilterType={OUTPUT_PHRASES}
                                                    count={outputPhrasesCount}
                                                    classes={filterCheckBoxClass + ' output-phrases-ch'}
                                                    isNew={outputPhrasesLastTs > lastScrollTs}
                                                    onReadLogs={this.markLogsAsReadWithFilter}
                                                    onClick={this.setOutputPhrasesFilter}
                                                    value={filters[OUTPUT_PHRASES]} />}

                                            {dialogAndScriptfilters}

                                        </div>

                                    </div>
                                </div>
                                <div className="error-panel_first-row_right-controls">
                                    <FilterDelimiter height="22px" classes={`${filters['syntaxErrors'] && 'hidden'} filter-switcher-delimiter-export-logs`} />

                                    {showRefreshLogsBtn &&
                                        <div className={`error-panel_export-logs`}
                                            onClick={this.refreshLogs} title="Refresh logs">
                                            <i className="icon icon-alan-refresh refresh-logs-btn" title="Refresh logs" />
                                        </div>}

                                    <div className={`error-panel_export-logs ${filters['syntaxErrors'] && 'hidden'} ${project.exportingDialogs && 'disabled'}`}
                                        onClick={this.onExportDialogsClick} title="Download dialogs">
                                        <i className="icon-download-svg" title="Download dialogs">{icons.downloadDialogs}</i>
                                    </div>

                                    <div className={`error-panel_export-logs ${filters['syntaxErrors'] && 'hidden'} ${project.exportingLogs && 'disabled'}`}
                                        onClick={this.onExportLogsClick} title="Download logs">
                                        <i className="icon-download-svg" title="Download logs">{icons.downloadLogs}</i>
                                    </div>
                                    <div className={`error-panel_clear-logs ${filters['syntaxErrors'] && 'hidden'}`}
                                        onClick={this.props.clearLogsCb} title="Clear logs"><i className="icon icon-alan-trash" />

                                    </div>
                                    <FilterDelimiter height="22px"
                                        autoVerticalPosition={true}
                                        classes="filter-switcher-delimiter filter-switcher-delimiter-clear-log" />
                                    <i onClick={this.togglePanel}
                                        className="icon icon-alan-chevron-fat arrow-rect" />
                                </div>

                            </div>

                            <div className="error-panel_filters_row  filter-second-row">

                                <div className="filter-second-row_switchers">

                                    {dialogAndScriptfilters}

                                    {!filters.syntaxErrors && filters[PHRASE_FILTER] && <FilterLabel title="Phrase" onReset={resetPhraseTextFilter} />}

                                    {!filters.syntaxErrors && filters[PATTERNHASH_FILTER] && <FilterLabel title="Pattern" onReset={resetPatternFilter} />}

                                    {!filters.syntaxErrors && filters[DIALOG_FILTER] && <FilterLabel title="Dialog" onReset={resetDialogFilter} />}

                                    {!filters.syntaxErrors && filters.entities.map((entity, ind) => {
                                        return <FilterLabel key={ind} title={this.getEntityFilterLabel(entity)} entity={entity} onReset={resetEntityFilter} />;
                                    })}

                                    {(!filters.syntaxErrors && hasFilterByPhrases && showResetAllBtn) && <span className="error-panel_reset-all-filters" onClick={resetAllPhrasesFilters}>Reset Filters <i className="icon icon-alan-remove-fat" /></span>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="error-panel_body">
                        {displayedLogs.length > 0 ?
                            <div className="error-panel_list" ref="panelList">
                                <AutoSizer
                                    rowCount={displayedLogs.length}
                                    logsUpdatedTs={logsUpdatedTs}>
                                    {this.renderList}
                                </AutoSizer>

                                {showLogTooltip && this.getTooltipContent()}
                                {(opened && lastLogTs > this.state.lastScrollTs && this.autoscroll === false && !this.scrolledToBottom) &&
                                    <div className="error-panel_list_more action-btn light-blue-btn-badge"
                                        onClick={this.showMoreMessages}>
                                        More Messages
                                    </div>}
                            </div> :
                            <div className="error-panel_list" ref="panelList">
                                <div className="error-panel_no-errors">
                                    <div>
                                        <img src={noLogsImgEl} />
                                        <div>{noLogsMessage}</div>
                                    </div>
                                </div>
                            </div>
                        }
                        {!hasLoadedLogs &&
                            <div className="error-panel_laoder">
                                <Loader theme={LoaderTheme.Dark} size={LoaderSize.Medium} center={true} />
                            </div>}
                    </div>
                </div>
            </Resizer>
        );
    }
}



function mapStateToProps({ projectsInfo, scriptEditor, user }, ownProps) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        exportDialogs: (param) => asyncDispatch(exportDialogs, dispatch, param),
        exportLogs: (param) => asyncDispatch(exportLogs, dispatch, param),
        readLogs: (param) => asyncDispatch(readLogs, dispatch, param),
        markLogsAsRead: (param) => dispatch(markLogsAsRead(param)),
        openErrors: (param: scriptEditorActions.IOpenErrorsParams) => dispatch(scriptEditorActions.openErrors(param)),
    };
}


const connector = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true });

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ErrorPanel);
